module.exports = __webpack_public_path__ + "img/why.4ab00869.png";